import { createVolumeMeasurementController } from './volume-measurement-controller';
import { VolumetricMeasurementDetails } from './VolumetricMeasurementDetails';
import { VolumetricMeasurementOptions } from './VolumetricMeasurementOptions';

export const volumeMeasurementConfig = {
  detailsComponent: VolumetricMeasurementDetails,
  optionsComponent: VolumetricMeasurementOptions,
  createController: createVolumeMeasurementController,
};

export type {
  VolumeDetailsProps,
  VolumeMeasurementController,
} from './volume-measurement.types';
export type { VolumetricMeasurementDetailsProps } from './VolumetricMeasurementDetails';
export type { VolumetricMeasurementOptionsProps } from './VolumetricMeasurementOptions';
export {
  VolumetricMeasurementDetails,
  VolumetricMeasurementOptions,
  createVolumeMeasurementController,
};
